import { z } from 'zod';
import { uuidSchema } from './common';
import { recipeSchema } from './recipes';

export const menuInsightsQuerySchema = z.object({ from: z.iso.date(), to: z.iso.date() });
export const menuInsightsSchema = z.object({
  menu_item_id: uuidSchema,
  from: z.iso.date(),
  to: z.iso.date(),
  currency: z.string(),
  time_zone: z.string(),
  totals: z.object({
    quantity: z.number(),
    orders: z.number().int(),
    gross_minor: z.number().int(),
    branch_gross_minor: z.number().int(),
    costed_quantity: z.number(),
    costed_gross_minor: z.number().int(),
    recorded_cost_minor: z.number().int(),
    contribution_minor: z.number().int().nullable(),
  }),
  days: z.array(
    z.object({
      date: z.iso.date(),
      quantity: z.number(),
      gross_minor: z.number().int(),
      orders: z.number().int(),
      promo: z.boolean(),
    }),
  ),
  modifiers: z.array(
    z.object({
      group_id: z.string(),
      group_name: z.string(),
      option_id: z.string(),
      option_name: z.string(),
      quantity: z.number(),
      extra_minor: z.number().int(),
    }),
  ),
  promotions: z.array(
    z.object({
      id: uuidSchema,
      title: z.string(),
      from: z.iso.date(),
      to: z.iso.date(),
      days: z.number().int(),
      quantity: z.number(),
      gross_minor: z.number().int(),
    }),
  ),
});
export type MenuInsights = z.infer<typeof menuInsightsSchema>;
export const recipeHistoryQuerySchema = z.object({
  before_version: z.coerce.number().int().positive().optional(),
});
export const recipeHistorySchema = z.object({
  items: z.array(
    z.object({
      version: z.number().int(),
      recorded_at: z.string(),
      baseline: z.boolean(),
      snapshot: recipeSchema,
    }),
  ),
  next_before_version: z.number().int().nullable(),
});
export type RecipeHistory = z.infer<typeof recipeHistorySchema>;
